// ✅ ChatProvider.js MODIFIED
import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";
import socket from "../socket";

const ChatContext = createContext();
const INACTIVITY_LIMIT = 10 * 60 * 1000;

const ChatProvider = ({ children }) => {
  const [selectedChat, setSelectedChat] = useState();
  const [user, setUser] = useState();
  const [chats, setChats] = useState([]);
  const [messages, setMessages] = useState([]);
  const [unreadCounts, setUnreadCounts] = useState({}); // ✅ NEW

  const inactivityTimeout = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    setUser(userInfo);
    if (!userInfo) navigate("/");

    const storedChat = localStorage.getItem("selectedChat");
    if (storedChat) {
      setSelectedChat(JSON.parse(storedChat));
    }
  }, [navigate]);

  // Load unreadCounts from localStorage on mount
  useEffect(() => {
    const savedCounts = localStorage.getItem("unreadCounts");
    if (savedCounts) setUnreadCounts(JSON.parse(savedCounts));
  }, []);

  // Save unreadCounts to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("unreadCounts", JSON.stringify(unreadCounts));
  }, [unreadCounts]);

  useEffect(() => {
    if (!user?._id) return;

    if (!socket.connected) {
      socket.connect();
      console.log("Socket connecting in ChatProvider");
    }

    socket.emit("setup", user);
    socket.emit("user active", user._id);

    const handleReconnect = () => {
      socket.emit("setup", user);
      socket.emit("user active", user._id);
    };

    socket.on("reconnect", handleReconnect);

    const goInactive = () => {
      if (user?._id) socket.emit("user inactive", user._id);
    };

    const resetInactivityTimer = () => {
      clearTimeout(inactivityTimeout.current);
      inactivityTimeout.current = setTimeout(goInactive, INACTIVITY_LIMIT);
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        resetInactivityTimer();
      } else {
        clearTimeout(inactivityTimeout.current);
        socket.emit("user active", user._id);
      }
    };

    const handleBeforeUnload = () => {
      if (user?._id) socket.emit("user offline", user._id);
    };

    const handleFocus = () => {
      clearTimeout(inactivityTimeout.current);
      socket.emit("user active", user._id);
    };

    window.addEventListener("focus", handleFocus);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("beforeunload", handleBeforeUnload);
    resetInactivityTimer();

    return () => {
      window.removeEventListener("focus", handleFocus);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
      clearTimeout(inactivityTimeout.current);
      socket.off("reconnect", handleReconnect);
    };
  }, [user]);

  return (
    <ChatContext.Provider
      value={{
        selectedChat,
        setSelectedChat,
        user,
        setUser,
        chats,
        setChats,
        messages,
        setMessages,
        unreadCounts,
        setUnreadCounts, // ✅ NEW
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export const ChatState = () => useContext(ChatContext);
export default ChatProvider;
